import { render, staticRenderFns } from "./DetailTxt.vue?vue&type=template&id=46147315&scoped=true"
import script from "./DetailTxt.vue?vue&type=script&lang=js"
export * from "./DetailTxt.vue?vue&type=script&lang=js"
import style0 from "./DetailTxt.vue?vue&type=style&index=0&id=46147315&prod&lang=less"
import style1 from "./DetailTxt.vue?vue&type=style&index=1&id=46147315&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46147315",
  null
  
)

export default component.exports